module.exports = __webpack_public_path__ + "img/nature33.ca456d0c.jpg";